/**
 * Реестр доменов платформенной зоны (команда Skrezo) — единственное
 * место, где перечислено содержимое сайдбара И protected-роутов. Меняем
 * здесь — меняется и меню (AppShell), и роуты (AppRouter).
 *
 * Разделы: дашборд, клиенты, аккаунты, заявки, отчёты, расход, тарифы,
 * платежи, система, журнал.
 *
 * `permission` — placeholder под v2 (роли внутри команды Skrezo). В v1
 * доступ общий, поле держим null.
 *
 * Кабинет клиники (клиентский контур) — отдельная зона со своим реестром
 * и layout'ом; здесь не смешиваем (разные контуры авторизации).
 */

import type {ReactNode} from 'react';
import {createElement} from 'react';
import {
  Activity,
  ChartColumn,
  CreditCard,
  Gauge,
  Inbox,
  LayoutDashboard,
  ScrollText,
  Tags,
  UserCog,
  Users,
} from 'lucide-react';

export type DomainId =
  | 'dashboard'
  | 'clients'
  | 'accounts'
  | 'applications'
  | 'reports'
  | 'usage'
  | 'tariffs'
  | 'payments'
  | 'system'
  | 'audit';

export type DomainLeaf = {
  id: string;
  path: string;
  title: string;
  permission: string | null;
};

export type DomainSection = {
  id: DomainId;
  path: string;
  title: string;
  icon: ReactNode;
  permission: string | null;
  children: readonly DomainLeaf[];
};

export const DOMAINS: readonly DomainSection[] = [
  {
    id: 'dashboard',
    path: '/dashboard',
    title: 'Дашборд',
    icon: createElement(LayoutDashboard),
    permission: null,
    children: [],
  },
  {
    id: 'clients',
    path: '/clients',
    title: 'Клиенты',
    icon: createElement(Users),
    permission: null,
    children: [],
  },
  {
    id: 'accounts',
    path: '/accounts',
    title: 'Аккаунты',
    icon: createElement(UserCog),
    permission: null,
    children: [],
  },
  {
    id: 'applications',
    path: '/applications',
    title: 'Заявки',
    icon: createElement(Inbox),
    permission: null,
    children: [],
  },
  {
    id: 'reports',
    path: '/reports',
    title: 'Отчёты',
    icon: createElement(ChartColumn),
    permission: null,
    children: [],
  },
  {
    id: 'usage',
    path: '/usage',
    title: 'Расход',
    icon: createElement(Gauge),
    permission: null,
    children: [],
  },
  {
    id: 'tariffs',
    path: '/tariffs',
    title: 'Тарифы',
    icon: createElement(Tags),
    permission: null,
    children: [],
  },
  {
    id: 'payments',
    path: '/payments',
    title: 'Платежи',
    icon: createElement(CreditCard),
    permission: null,
    children: [],
  },
  {
    id: 'system',
    path: '/system',
    title: 'Система',
    icon: createElement(Activity),
    permission: null,
    children: [],
  },
  {
    id: 'audit',
    path: '/audit',
    title: 'Журнал',
    icon: createElement(ScrollText),
    permission: null,
    children: [],
  },
];
